/*
This code was part of checkout.liquid which was rendered after an order was placed. We migrated here when the thank you page was migrated to checkout extensibility.

- Remove TrueSize Cookie:
    Key: _tl_persona_true_size_loaded
    So that it perform a fresh load of the values from server side

- Remove gift note flag from localStorage:
    Key: tl_checkout_gift-note
    I am not sure if we are still using it. Check.

- Remove Discounts Cookies:
    Keys: discount_code and _tl_discount_products
    I am not sure if we are still using them. Check.

- Add Recurring Customer Cookie:
    Key: _tl_recurring_customer
*/

/*
const DISCOUNT_PRODUCTS = '_tl_discount_products';
const SHOPIFY_DISCOUNT_CODE_COOKIE = 'discount_code';
const DISCOUNT_CODE_QUERY_SELECTOR = 'span.reduction-code > span';
*/

/*
  Remove True Size cookie so that it perform a fresh load of the values
  from server side

  function removeTrueSizeCookie() {
    jsCookie.remove('_tl_persona_true_size_loaded');
  }
*/

/*
  Removes Gift Note flag from local storage
*/
function removeGiftNoteFlag() {
  localStorage && localStorage.removeItem('tl_checkout_gift-note');
}

/*
  Remove discount related cookies so that it not get messed up with futures discounts the user may apply.

  function removeDiscountCookies() {
    
    // Clean up discount code cookie
    jsCookie.remove(SHOPIFY_DISCOUNT_CODE_COOKIE);
    jsCookie.remove(DISCOUNT_PRODUCTS);
  }
  */

/*
  Creates a cookie to flag the customer as recurring.
  There's a snippet in GTM for flagging blackcart customers (TBB - TBYB).

  function addCustomerCookie() {
    jsCookie.set('_tl_recurring_customer', true, { expires: 18 * 30 });
  }
  */

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

function removeCookie(name) {
  console.log("Removing cookie: _thank_you_page_first_access=");
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`; // Set old date
}

function onDOMReady() {
  if(getCookie("_thank_you_page_first_access")) {
    console.log("First access after Thank You Page detected.");

    // Run functions to remove cookies and local storage items
    //removeTrueSizeCookie();
    removeGiftNoteFlag();
    //removeDiscountCookies();
    //addCustomerCookie();

    // Remove cookie after first access after thank you page
    removeCookie("_thank_you_page_first_access");
  }
  else {
    console.log("Cookie not detected: _thank_you_page_first_access");
  }

  // Check if there is a cookie with customer email who placed the last order
  if(getCookie("_customer_email")) {
    console.log("Has customer email cookie: _customer_email=" + getCookie("_customer_email"));

    // Set True Size Email on LocalStorage - Convert customer email from binary to ASCII
    localStorage.setItem('true_size_email_btoa', btoa(getCookie("_customer_email")));
  }
  else {
    console.log("No customer email cookie detected: _customer_email");
  }
}

window.addEventListener('DOMContentLoaded', onDOMReady, false);